export const formatRows = (listaItems) =>
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    codigo: item.codigo_ramo || "Código no disponible",
    descripcion: item.descripcion_ramo || "Ramo no disponible",
    web: item.ramo_show_web === 0 ? "✅" : "❌",
    app: item.ramo_show_app === 0 ? "✅" : "❌",
    
  }));
